import styled from 'styled-components';
import { Box } from '@scope/scope-one-ui/core/Box';
import { COLORS, SIZES } from '@scope/scope-one-ui/theme';

export const Tooltip = styled(Box)`
  max-width: ${SIZES.spacing(42)};
  color: ${COLORS.typography.main};
  white-space: normal;

  span {
    color: ${COLORS.typography.label};
  }
`;
